import { Injectable } from '@angular/core';
import { Observable, Subject } from 'rxjs';
import { PropertyUtils } from '@article/util/property-utils';
import { document } from 'ngx-bootstrap/utils';
import { UserModel } from '@user/model/user.model';
import { ProjectModel } from '../../../model/project.model';

@Injectable({ providedIn: 'root' })
export class ProjectValidationService {

  constructor(
    private userModel: UserModel,
    private projectModel: ProjectModel,
  ) {
  }

  private validateProjectViewSubject: Subject<void> = new Subject<void>();
  public get validateProjectView$(): Observable<void> {
    return this.validateProjectViewSubject.asObservable();
  }

  public notifyValidateProjectView(): void {
    this.validateProjectViewSubject.next();
  }

  public isExamineProjectEnabled(): boolean {
    return (
      this.userModel.user &&
      this.userModel.user.hasPermission("VALIDATE_PROJECT") &&
      PropertyUtils.isProjectValidatable(this.projectModel.currentProjectType)
    );
  }

  public examineProject(): void {
    if (!document.querySelector('body').classList.contains('aside-menu-plausi')) {
      document.querySelector('body').classList.add('aside-menu-plausi');
    }
    document.querySelector('body')!.classList.remove('aside-menu-label-editor');
    this.notifyValidateProjectView();
  }

  public closeValidateProjectView(): void {
    document.querySelector('body').classList.remove('aside-menu-plausi');
  }
}
